import { DataService } from './../../../../../services/data.service';
import swal from 'sweetalert2';
import { GalleryItem } from './../../../../../interfaces/settings';
import { Lightbox } from 'ngx-lightbox';
import { Drawing } from './../../../../../interfaces/course';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import * as _ from 'lodash';
import * as uuid from 'uuid/v1';

@Component({
  selector: 'app-super-admin-gallery',
  templateUrl: './super-admin-gallery.component.html',
  styleUrls: ['./super-admin-gallery.component.scss']
})
export class SuperAdminGalleryComponent implements OnInit {

  images: Drawing[];

  currentPage = 1;
  totalItemsPerPage = 20;

  isLoadingDrawings = false;

  constructor(
    private toastr: ToastrService,
    private _lightbox: Lightbox,
    private data: DataService
  ) { }

  ngOnInit() {
    this.getData();
  }

  getData(){
    this.data.getSettings('configs').subscribe((res) => {
      if(res && res.data){
        this.images = res.data.images;
      }
    })
  }

  async delete(src){
    const images = _.filter(Array.prototype.slice.call(this.images), i => i.src !== src);

    this.data.updateSettings('configs', {
      images: images
    }).subscribe((res) => {
      if(res){
        this.getData();
      }
    })
  }

  open(src: string){
    this._lightbox.open([{src: src, thumb: src}]);
  }

  upload(){
    try{
      swal.fire({
        title: 'Select drawing',
        input: 'file',
        inputAttributes: {
          'accept': 'image/*',
          'aria-label': 'Upload your file'
        },
        confirmButtonText: 'Next &rarr;',
        showCancelButton: true,
      }).then(async({value}) => {
        try{
          this.isLoadingDrawings = true;

          if (value) {
            const fileData: GalleryItem = {};

            const file: File = value;

            if(file.size > 10 * 1000 * 1000){
              throw Error('File is too big');
            }

            const key = `${uuid()}.${_.last(_.split(file.name, '.'))}`;

            const res = await this.data.presignS3File(key, file.type).toPromise();

            if(!res || !res.url){
              throw Error('Something went wrong.');
            }

            await this.data.uploadS3File(res.url, file).toPromise();

            fileData.src = `https://bilinstudio-assets.s3.us-east-2.amazonaws.com/${key}`;
            fileData.date = new Date();

            const images = Array.prototype.slice.call(this.images);

            images.push(fileData);

            this.data.updateSettings('configs', {
              images: images
            }).subscribe((res) => {
              if(res){
                this.getData();
              }
            })
          }
        }catch({message}){
          this.toastr.error(message);
        }finally{
          this.isLoadingDrawings = false;
        }
      })

    }catch({message}){
      this.toastr.error(message);
    }
  }
}
